import axios from 'axios';
import { modalContentMock } from 'test/mock/modalContentMock';

import { TGetLiferayModalContentResponse } from './types';

export const getModalContent = async (liferayDomain: string, siteId: string) => {
  const vbzDebug = localStorage.getItem('vbzDebug');

  const url = `${liferayDomain}/o/headless-delivery/v1.0/sites/${siteId}/structured-contents?flatten=true&filter=friendlyUrlPath eq 'mmc_modal_period'`;

  if (vbzDebug === 'true') {
    return modalContentMock.items[0].contentFields[0].contentFieldValue.data;
  }

  return axios.get<TGetLiferayModalContentResponse>(url).then((res) => {
    return res.data.items[0].contentFields[0].contentFieldValue.data;
  });
};
